import { ITeamBookingOverviewQuery } from '../interfaces/team-booking-overview.query.interface';

export class TeamBookingOverview {
    openBookingRequestCount: number;

    constructor(query: ITeamBookingOverviewQuery) {
        this.openBookingRequestCount = query?.open_booking_request_count || 0;
    }
}
